import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { LocalOrderReference } from '@asm/features/quick-order/models/offline-reference-data.model';

@Injectable({ providedIn: 'root' })
export class OrderReferenceRepository extends RepositoryBase<LocalOrderReference> {
  protected readonly KEY_PATH = 'orders';
}
